import { get } from "../services/Generic.api";

const isoToBR = (iso) => {
  if (!iso) return null;
  if (typeof iso !== "string") return null;

  if (/^\d{2}\/\d{2}\/\d{4}$/.test(iso)) return iso;

  if (/^\d{4}-\d{2}-\d{2}$/.test(iso)) {
    const [y, m, d] = iso.split("-");
    return `${d}/${m}/${y}`;
  }

  const dt = new Date(iso);
  if (Number.isNaN(dt.getTime())) return null;

  const d = String(dt.getDate()).padStart(2, "0");
  const m = String(dt.getMonth() + 1).padStart(2, "0");
  const y = dt.getFullYear();
  return `${d}/${m}/${y}`;
};

export const buildDashboardParams = (filters) => {
  const clientId = filters?.clientId ?? localStorage.getItem("clientId");
  const searchText = String(filters?.text || "").trim() || null;

  const mediaType = (() => {
    const media = filters?.media;

    if (Array.isArray(media)) {
      const selectedMedia = media
        .map((item) => String(item || "").trim())
        .filter(Boolean);

      return selectedMedia.length ? selectedMedia.join(",") : null;
    }

    if (typeof media === "string") {
      const normalizedMedia = media.trim();
      return normalizedMedia && normalizedMedia !== "all" ? normalizedMedia : null;
    }

    return null;
  })();

  const evaluationStatus =
    filters?.evaluation || "all"; 

  const polarity = (() => {
    const s = filters?.sentiment;
    if (!s || s === "neutral") return null; 
    if (s === "positive") return "positiva";
    if (s === "negative") return "negativa";
    if (s === "neutral") return "neutra";
    return null;
  })();

  if (filters?.selection) {
    return {
      client: clientId,
      clipping_selection: filters.selection,
      category: filters?.category || null,
      source: filters?.sources?.[0] ?? null,
      subject: filters?.subject || null,
      text: searchText,
      media_type: mediaType,
      evaluation_status: evaluationStatus,
      polarity: polarity,
    };
  }

  return {
    client: clientId,
    date_start: isoToBR(filters?.startDate),
    date_end: isoToBR(filters?.endDate),
    category: filters?.category || null,
    source: filters?.sources?.[0] ?? null,
    subject: filters?.subject || null,
    text: searchText,
    clipping_selection: null,
    media_type: mediaType,
    evaluation_status: evaluationStatus,
    polarity: polarity,
  };
};

export const fetchDashboardTotalClippings = async (filters) => {
  return get(
    "/dashboard/dashboard-total-clippings/",
    buildDashboardParams(filters)
  );
};

export const fetchDashboardTotalValuation = async (filters) => {
  return get(
    "/dashboard/dashboard-total-valuation/",
    buildDashboardParams(filters)
  );
};

export const fetchDashboardTotalAudience = async (filters) => {
  return get(
    "/dashboard/dashboard-clippings-total-audience/",
    buildDashboardParams(filters)
  );
};

export const fetchDashboardMediaTypes = async (filters) => {
  return get(
    "/dashboard/dashboard-media-types/",
    buildDashboardParams(filters)
  );
};

export const fetchDashboardClippingsByState = async (filters) => {
  return get(
    "/dashboard/dashboard-clippings-by-state/",
    buildDashboardParams(filters)
  );
};

export const fetchDashboardClippingsPerDay = async (filters) => {
  return get(
    "/dashboard/dashboard-clippings-per-day/",
    buildDashboardParams(filters)
  );
};

export const fetchDashboardQualitativeDistribution = async (filters) => {
  return get(
    "/dashboard/dashboard-qualitative-distribution/",
    buildDashboardParams(filters)
  );
};

export const fetchDashboardTags = async (filters) => {
  return get(
    "/dashboard/dashboard-tags/",
    buildDashboardParams(filters)
  );
};

export const fetchDashboardProtagonismDistribution = async (filters) => {
  return get(
    "/dashboard/dashboard-media-analysis-protagonisms/",
    buildDashboardParams(filters)
  );
};

export const fetchDashboardProtagonismBySubject = async (filters) => {
  return get(
    "/dashboard/dashboard-media-analysis-protagonism-per-subject/",
    buildDashboardParams(filters)
  );
};

export const fetchDashboardSourcesPerMarketingValue = async (filters) => {
  return get(
    "/dashboard/sources-per-marketing-value/",
    buildDashboardParams(filters)
  );
};

export const fetchDashboardTopVehiclesQualitative = async (filters) => {
  return get(
    "/dashboard/dashboard-top-vehicles-qualitative/",
    buildDashboardParams(filters)
  );
};

export const fetchDashboardTotalVehicles = async (filters) => {
  return get(
    "/dashboard/dashboard-total-vehicles/",
    buildDashboardParams(filters)
  );
};

export const fetchDashboardSubjectsPerDay = async (filters) => {
  return get(
    "/dashboard/dashboard-subjects-per-day/",
    buildDashboardParams(filters)
  );
};

export const fetchDashboardOccupiedSpaceByMediaType = async (filters) => {
  return get(
    "/dashboard/dashboard-occupied-space-by-media-type/",
    buildDashboardParams(filters)
  );
};

export const fetchDashboardReleaseOrigin = async (filters) => {
  return get(
    "/dashboard/dashboard-release-origin/",
    buildDashboardParams(filters)
  );
};

export const fetchDashboardReleasePerDay = async (filters) => {
  return get(
    "/dashboard/dashboard-release-per-day/",
    buildDashboardParams(filters)
  );
};

export const fetchDashboardReleasePerMediaType = async (filters) => {
  return get(
    "/dashboard/dashboard-release-per-media-type/",
    buildDashboardParams(filters)
  );
};

export const fetchDashboardReleaseTopVehicles = async (filters) => {
  return get(
    "/dashboard/dashboard-release-top-vehicles/",
    buildDashboardParams(filters)
  );
};
